import styles from '../styles/pagination.module.css';

const Pagination = ({ currentPage,  onPageChange }) => {
  return (
    <div className={styles.container}>

    

    <div className={styles.stepsIndicator}>
          <div onClick={() => onPageChange(currentPage - 1)}  className={styles.stepCircle}>→</div>
    
          <span className={styles.pageInfo}>
        1 2 3 4 ...9
      </span>
          <div className={styles.stepCircle}>→</div>
        </div>
     


    </div>
  );
};

export default Pagination;
